import { render, staticRenderFns } from "./TradeHistoryScreen.vue?vue&type=template&id=ca3c80f2&scoped=true"
import script from "./TradeHistoryScreen.vue?vue&type=script&lang=js"
export * from "./TradeHistoryScreen.vue?vue&type=script&lang=js"
import style0 from "./TradeHistoryScreen.vue?vue&type=style&index=0&id=ca3c80f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3c80f2",
  null
  
)

export default component.exports